import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Skills.scss";

const Skills = () => {
  const [experiences, setExperiences] = useState([]);

  const [skills, setSkills] = useState([]);
  const [filterSkills, setFilterSkills] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "workExperience"]';
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(query).then((data) => {
      data.sort((a, b) => new Date(b._updatedAt) - new Date(a._updatedAt));
      setExperiences(data);
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
      setFilterSkills(data);
    });
  }, []);

  const handleSkillsFilter = (item) => {
    setActiveFilter(item);
    if (item === "All") {
      setFilterSkills(skills);
    } else {
      setFilterSkills(skills.filter((skill) => skill.tags.includes(item)));
    }
  };

  return (
    <>
      <h2 className="head-text">
        <span>SKILLS</span> & EXPERIENCES
      </h2>

      <div className="app__skill-filter">
        {["All", "Web", "Languages", "Frameworks", "Softwares", "More"].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleSkillsFilter(item)}
              className={`app__skill-filter-item app__flex m-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {filterSkills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="m-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience.experience}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.experience}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                <>
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__skills-exp-work"
                    data-tip
                    data-for={experience.name}
                    key={experience.name}
                  >
                    <h4 className="bold-text">{experience.name}</h4>
                    <p className="m-text">{experience.company}</p>
                    <p className="m-text">{experience.description}</p>
                  </motion.div>
                </>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
